
export const appendDirectReport = (stateData, newData, parentId) => {
  const updatedHierarchy = stateData.map(user => {
    if (user.id === parentId) {
      user.directReports = newData;
    } else if (user.directReports) {
      user.directReports = appendDirectReport(user.directReports, newData, parentId);
    }
    return user;
  });

  return updatedHierarchy;
}